'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var maybePromoteScalarValueIntoResponsive = function maybePromoteScalarValueIntoResponsive(value) {
  var isResponsive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  /**
   * Responsive value must necessarily have the desktop key attached to it
   */
  if (value && Object.keys(value).indexOf('desktop') > -1) {
    if (!isResponsive) {
      return value.desktop;
    }

    return value;
  }

  if (!isResponsive) {
    return value;
  }

  return {
    desktop: value,
    tablet: value,
    mobile: value
  };
};

exports.maybePromoteScalarValueIntoResponsive = maybePromoteScalarValueIntoResponsive;
//# sourceMappingURL=promote-into-responsive.js.map
